/* eslint-disable max-len */
import { listLotAllocationsApi } from 'api/inventory';
import { inventoryActions } from 'store/slices/inventorySlice';
import { handleError } from './errorHandlerThunks';

const QUEUE = 'reversalQueue';
const PAGE_SIZE = 25;

export const loadReversalQueuePage =
  ({ page }) =>
  (dispatch, getState) => {
    const { filter, sort } = getState().inventory[QUEUE];

    dispatch(inventoryActions.updateInventoryQueuePage({ queue: QUEUE, page }));
    dispatch(inventoryActions.setInventoryQueueLoading({ queue: QUEUE, loading: true }));

    return listLotAllocationsApi({
      filter: { ...filter, taggedForReview: true },
      sort,
      limit: PAGE_SIZE,
      offset: (page - 1) * PAGE_SIZE,
    })
      .then(({ items, total }) =>
        dispatch(
          inventoryActions.loadInventoryQueueToPage({
            queue: QUEUE,
            page,
            items,
            totalCount: total,
          })
        )
      )
      .catch((error) => dispatch(handleError({ error })))
      .finally(() =>
        dispatch(inventoryActions.setInventoryQueueLoading({ queue: QUEUE, loading: false }))
      );
  };

export const filterReversalQueue =
  ({ filter }) =>
  (dispatch) => {
    dispatch(inventoryActions.updateInventoryQueueFilter({ queue: QUEUE, filter }));
    dispatch(loadReversalQueuePage({ page: 1 }));
  };

export const updateReversalQueueSort =
  ({ sort }) =>
  (dispatch) => {
    dispatch(inventoryActions.updateInventoryQueueSort({ queue: QUEUE, sort }));
    dispatch(loadReversalQueuePage({ page: 1 }));
  };
